import { render, staticRenderFns } from "./ColumnResize.vue?vue&type=template&id=a99365c6&lang=pug"
import script from "./ColumnResize.vue?vue&type=script&lang=js"
export * from "./ColumnResize.vue?vue&type=script&lang=js"
import style0 from "./ColumnResize.vue?vue&type=style&index=0&id=a99365c6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports